import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useCustomerStore = defineStore('customer', () => {
    const all = ref(null);

    const actions = {
        search: (params) => axios.get('/api/v1/customers', { params }),
        storeCustomer: (params) => axios.post('/api/v1/customers', params),
        updateCustomer: (params) => axios.patch('/api/v1/customers/' + params.hash, params),
    };

    return {
        all,
        ...actions,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useCustomerStore.acceptHMRUpdate);
}
